export const countries = [
  {
    ISO: 'AUT',
    NAME: 'Austria',
    CODE: 'AT',
    NUMERIC_CODE: 40,
    TELEPHONEACCESSCODE: 43,
  },
  {
    ISO: 'BEL',
    NAME: 'Belgium',
    CODE: 'BE',
    NUMERIC_CODE: 56,
    TELEPHONEACCESSCODE: 32,
  },
  {
    ISO: 'BGR',
    NAME: 'Bulgaria',
    CODE: 'BG',
    NUMERIC_CODE: 100,
    TELEPHONEACCESSCODE: 359,
  },
  {
    ISO: 'BES',
    NAME: 'Bonaire',
    CODE: 'BQ',
    NUMERIC_CODE: 535,
    TELEPHONEACCESSCODE: 599,
  },
  {
    ISO: 'CHE',
    NAME: 'Switzerland',
    CODE: 'CH',
    NUMERIC_CODE: 756,
    TELEPHONEACCESSCODE: 41,
  },
  {
    ISO: 'CYP',
    NAME: 'Cyprus',
    CODE: 'CY',
    NUMERIC_CODE: 196,
    TELEPHONEACCESSCODE: 357,
  },
  {
    ISO: 'CZE',
    NAME: 'Czech Republic',
    CODE: 'CZ',
    NUMERIC_CODE: 203,
    TELEPHONEACCESSCODE: 420,
  },
  {
    ISO: 'CUW',
    NAME: 'Curaçao',
    CODE: 'CW',
    NUMERIC_CODE: 531,
    TELEPHONEACCESSCODE: 599,
  },
  {
    ISO: 'DEU',
    NAME: 'Germany',
    CODE: 'DE',
    NUMERIC_CODE: 276,
    TELEPHONEACCESSCODE: 49,
  },
  {
    ISO: 'DNK',
    NAME: 'Denmark',
    CODE: 'DK',
    NUMERIC_CODE: 208,
    TELEPHONEACCESSCODE: 45,
  },
  {
    ISO: 'ESP',
    NAME: 'Spain',
    CODE: 'ES',
    NUMERIC_CODE: 724,
    TELEPHONEACCESSCODE: 34,
  },
  {
    ISO: 'EST',
    NAME: 'Estonia',
    CODE: 'EE',
    NUMERIC_CODE: 233,
    TELEPHONEACCESSCODE: 372,
  },
  {
    ISO: 'FIN',
    NAME: 'Finland',
    CODE: 'FI',
    NUMERIC_CODE: 246,
    TELEPHONEACCESSCODE: 358,
  },
  {
    ISO: 'FRA',
    NAME: 'France',
    CODE: 'FR',
    NUMERIC_CODE: 250,
    TELEPHONEACCESSCODE: 33,
  },
  {
    ISO: 'GBR',
    NAME: 'United Kingdom',
    CODE: 'GB',
    NUMERIC_CODE: 826,
    TELEPHONEACCESSCODE: 44,
  },
  {
    ISO: 'GRC',
    NAME: 'Greece',
    CODE: 'GR',
    NUMERIC_CODE: 300,
    TELEPHONEACCESSCODE: 30,
  },
  {
    ISO: 'HRV',
    NAME: 'Croatia',
    CODE: 'HR',
    NUMERIC_CODE: 191,
    TELEPHONEACCESSCODE: 385,
  },
  {
    ISO: 'IRL',
    NAME: 'Ireland',
    CODE: 'IE',
    NUMERIC_CODE: 372,
    TELEPHONEACCESSCODE: 353,
  },
  {
    ISO: 'ISL',
    NAME: 'Iceland',
    CODE: 'IS',
    NUMERIC_CODE: 352,
    TELEPHONEACCESSCODE: 354,
  },
  {
    ISO: 'ITA',
    NAME: 'Italy',
    CODE: 'IT',
    NUMERIC_CODE: 380,
    TELEPHONEACCESSCODE: 39,
  },
  {
    ISO: 'LIE',
    NAME: 'Liechtenstein',
    CODE: 'LI',
    NUMERIC_CODE: 438,
    TELEPHONEACCESSCODE: 423,
  },
  {
    ISO: 'LVA',
    NAME: 'Latvia',
    CODE: 'LV',
    NUMERIC_CODE: 428,
    TELEPHONEACCESSCODE: 371,
  },
  {
    ISO: 'MLT',
    NAME: 'Malta',
    CODE: 'MT',
    NUMERIC_CODE: 470,
    TELEPHONEACCESSCODE: 356,
  },
  {
    ISO: 'MAR',
    NAME: 'Morocco',
    CODE: 'MA',
    NUMERIC_CODE: 212,
    TELEPHONEACCESSCODE: 212,
  },
  {
    ISO: 'NLD',
    NAME: 'Netherlands',
    CODE: 'NL',
    NUMERIC_CODE: 528,
    TELEPHONEACCESSCODE: 31,
  },
  {
    ISO: 'NOR',
    NAME: 'Norway',
    CODE: 'NO',
    NUMERIC_CODE: 578,
    TELEPHONEACCESSCODE: 47,
  },
  {
    ISO: 'POL',
    NAME: 'Poland',
    CODE: 'PL',
    NUMERIC_CODE: 616,
    TELEPHONEACCESSCODE: 48,
  },
  {
    ISO: 'PRT',
    NAME: 'Portugal',
    CODE: 'PT',
    NUMERIC_CODE: 620,
    TELEPHONEACCESSCODE: 351,
  },
  {
    ISO: 'RUS',
    NAME: 'Russia',
    CODE: 'RU',
    NUMERIC_CODE: 643,
    TELEPHONEACCESSCODE: 7,
  },
  {
    ISO: 'SVK',
    NAME: 'Slovakia',
    CODE: 'SK',
    NUMERIC_CODE: 703,
    TELEPHONEACCESSCODE: 421,
  },
  {
    ISO: 'SVN',
    NAME: 'Slovenia',
    CODE: 'SI',
    NUMERIC_CODE: 705,
    TELEPHONEACCESSCODE: 386,
  },
  {
    ISO: 'SWE',
    NAME: 'Sweden',
    CODE: 'SE',
    NUMERIC_CODE: 752,
    TELEPHONEACCESSCODE: 46,
  },
  {
    ISO: 'AFG',
    NAME: 'Afghanistan',
    CODE: 'AF',
    NUMERIC_CODE: 146,
    TELEPHONEACCESSCODE: 93,
  },
  {
    ISO: 'ALB',
    NAME: 'Albania',
    CODE: 'AL',
    NUMERIC_CODE: 148,
    TELEPHONEACCESSCODE: 355,
  },
  {
    ISO: 'DZA',
    NAME: 'Algeria',
    CODE: 'DZ',
    NUMERIC_CODE: 45,
    TELEPHONEACCESSCODE: 213,
  },
  {
    ISO: 'AGO',
    NAME: 'Angola',
    CODE: 'AO',
    NUMERIC_CODE: 152,
    TELEPHONEACCESSCODE: 244,
  },
  {
    ISO: 'AIA',
    NAME: 'Anguilla',
    CODE: 'AI',
    NUMERIC_CODE: 10003773,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'ARG',
    NAME: 'Argentina',
    CODE: 'AR',
    NUMERIC_CODE: 155,
    TELEPHONEACCESSCODE: 54,
  },
  {
    ISO: 'ARM',
    NAME: 'Armenia',
    CODE: 'AM',
    NUMERIC_CODE: 2001,
    TELEPHONEACCESSCODE: 374,
  },
  {
    ISO: 'ABW',
    NAME: 'Aruba',
    CODE: 'AW',
    NUMERIC_CODE: 157,
    TELEPHONEACCESSCODE: 297,
  },
  {
    ISO: 'AUS',
    NAME: 'Australia',
    CODE: 'AU',
    NUMERIC_CODE: 159,
    TELEPHONEACCESSCODE: 61,
  },
  {
    ISO: 'AZE',
    NAME: 'Azerbaijan',
    CODE: 'AZ',
    NUMERIC_CODE: 147,
    TELEPHONEACCESSCODE: 994,
  },
  {
    ISO: 'BHS',
    NAME: 'Bahamas (the)',
    CODE: 'BS',
    NUMERIC_CODE: 160,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'BHR',
    NAME: 'Bahrain',
    CODE: 'BH',
    NUMERIC_CODE: 161,
    TELEPHONEACCESSCODE: 973,
  },
  {
    ISO: 'BGD',
    NAME: 'Bangladesh',
    CODE: 'BD',
    NUMERIC_CODE: 162,
    TELEPHONEACCESSCODE: 880,
  },
  {
    ISO: 'BRB',
    NAME: 'Barbados',
    CODE: 'BB',
    NUMERIC_CODE: 67000,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'BLZ',
    NAME: 'Belize',
    CODE: 'BZ',
    NUMERIC_CODE: 166,
    TELEPHONEACCESSCODE: 501,
  },
  {
    ISO: 'BEN',
    NAME: 'Benin',
    CODE: 'BJ',
    NUMERIC_CODE: 167,
    TELEPHONEACCESSCODE: 229,
  },
  {
    ISO: 'BMU',
    NAME: 'Bermuda',
    CODE: 'BM',
    NUMERIC_CODE: 168,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'BTN',
    NAME: 'Bhutan',
    CODE: 'BT',
    NUMERIC_CODE: 169,
    TELEPHONEACCESSCODE: 975,
  },
  {
    ISO: 'BOL',
    NAME: 'Bolivia',
    CODE: 'BO',
    NUMERIC_CODE: 170,
    TELEPHONEACCESSCODE: 591,
  },
  {
    ISO: 'BIH',
    NAME: 'Bosnia and Herzegovina',
    CODE: 'BA',
    NUMERIC_CODE: 172,
    TELEPHONEACCESSCODE: 387,
  },
  {
    ISO: 'BWA',
    NAME: 'Botswana',
    CODE: 'BW',
    NUMERIC_CODE: 173,
    TELEPHONEACCESSCODE: 267,
  },
  {
    ISO: 'BRA',
    NAME: 'Brazil',
    CODE: 'BR',
    NUMERIC_CODE: 4000,
    TELEPHONEACCESSCODE: 55,
  },
  {
    ISO: 'BRN',
    NAME: 'Brunei',
    CODE: 'BN',
    NUMERIC_CODE: 175,
    TELEPHONEACCESSCODE: 673,
  },
  {
    ISO: 'BFA',
    NAME: 'Burkina Faso',
    CODE: 'BF',
    NUMERIC_CODE: 177,
    TELEPHONEACCESSCODE: 226,
  },
  {
    ISO: 'BDI',
    NAME: 'Burundi',
    CODE: 'BI',
    NUMERIC_CODE: 178,
    TELEPHONEACCESSCODE: 257,
  },
  {
    ISO: 'KHM',
    NAME: 'Cambodia',
    CODE: 'KH',
    NUMERIC_CODE: 179,
    TELEPHONEACCESSCODE: 855,
  },
  {
    ISO: 'CAN',
    NAME: 'Canada',
    CODE: 'CA',
    NUMERIC_CODE: 6000,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'CHL',
    NAME: 'Chile',
    CODE: 'CL',
    NUMERIC_CODE: 186,
    TELEPHONEACCESSCODE: 56,
  },
  {
    ISO: 'CHN',
    NAME: 'China',
    CODE: 'CN',
    NUMERIC_CODE: 7000,
    TELEPHONEACCESSCODE: 86,
  },
  {
    ISO: 'COL',
    NAME: 'Colombia',
    CODE: 'CO',
    NUMERIC_CODE: 188,
    TELEPHONEACCESSCODE: 57,
  },
  {
    ISO: 'CUB',
    NAME: 'Cuba',
    CODE: 'CU',
    NUMERIC_CODE: 9000,
    TELEPHONEACCESSCODE: 53,
  },
  {
    ISO: 'DJI',
    NAME: 'Djibouti',
    CODE: 'DJ',
    NUMERIC_CODE: 199,
    TELEPHONEACCESSCODE: 253,
  },
  {
    ISO: 'ECU',
    NAME: 'Ecuador',
    CODE: 'EC',
    NUMERIC_CODE: 202,
    TELEPHONEACCESSCODE: 593,
  },
  {
    ISO: 'CRI',
    NAME: 'Costa Rica',
    CODE: 'CR',
    NUMERIC_CODE: 8000,
    TELEPHONEACCESSCODE: 506,
  },
  {
    ISO: 'EGY',
    NAME: 'Egypt',
    CODE: 'EG',
    NUMERIC_CODE: 14000,
    TELEPHONEACCESSCODE: 20,
  },
  {
    ISO: 'SLV',
    NAME: 'El Salvador',
    CODE: 'SV',
    NUMERIC_CODE: 204,
    TELEPHONEACCESSCODE: 503,
  },
  {
    ISO: 'ERI',
    NAME: 'Eritrea',
    CODE: 'ER',
    NUMERIC_CODE: 206,
    TELEPHONEACCESSCODE: 291,
  },
  {
    ISO: 'ETH',
    NAME: 'Ethiopia',
    CODE: 'ET',
    NUMERIC_CODE: 208,
    TELEPHONEACCESSCODE: 251,
  },
  {
    ISO: 'FRO',
    NAME: 'Faroe Islands',
    CODE: 'FO',
    NUMERIC_CODE: 9966809,
    TELEPHONEACCESSCODE: 298,
  },
  {
    ISO: 'FJI',
    NAME: 'Fiji',
    CODE: 'FJ',
    NUMERIC_CODE: 9,
    TELEPHONEACCESSCODE: 679,
  },
  {
    ISO: 'PHL',
    NAME: 'Philippines',
    CODE: 'PH',
    NUMERIC_CODE: 109,
    TELEPHONEACCESSCODE: 63,
  },
  {
    ISO: 'GAB',
    NAME: 'Gabon',
    CODE: 'GA',
    NUMERIC_CODE: 216,
    TELEPHONEACCESSCODE: 241,
  },
  {
    ISO: 'GMB',
    NAME: 'Gambia',
    CODE: 'GM',
    NUMERIC_CODE: 217,
    TELEPHONEACCESSCODE: 220,
  },
  {
    ISO: 'GEO',
    NAME: 'Georgia',
    CODE: 'GE',
    NUMERIC_CODE: 218,
    TELEPHONEACCESSCODE: 995,
  },
  {
    ISO: 'GIB',
    NAME: 'Gibraltar',
    CODE: 'GI',
    NUMERIC_CODE: 350,
    TELEPHONEACCESSCODE: 350,
  },
  {
    ISO: 'GHA',
    NAME: 'Ghana',
    CODE: 'GH',
    NUMERIC_CODE: 220,
    TELEPHONEACCESSCODE: 233,
  },
  {
    ISO: 'GRL',
    NAME: 'Greenland',
    CODE: 'GL',
    NUMERIC_CODE: 223,
    TELEPHONEACCESSCODE: 299,
  },
  {
    ISO: 'GTM',
    NAME: 'Guatemala',
    CODE: 'GT',
    NUMERIC_CODE: 227,
    TELEPHONEACCESSCODE: 502,
  },
  {
    ISO: 'GNB',
    NAME: 'Guinea-Bissau',
    CODE: 'GW',
    NUMERIC_CODE: 230,
    TELEPHONEACCESSCODE: 245,
  },
  {
    ISO: 'GUY',
    NAME: 'Guyana',
    CODE: 'GY',
    NUMERIC_CODE: 232,
    TELEPHONEACCESSCODE: 592,
  },
  {
    ISO: 'HTI',
    NAME: 'Haiti',
    CODE: 'HT',
    NUMERIC_CODE: 233,
    TELEPHONEACCESSCODE: 509,
  },
  {
    ISO: 'HND',
    NAME: 'Honduras',
    CODE: 'HN',
    NUMERIC_CODE: 10,
    TELEPHONEACCESSCODE: 504,
  },
  {
    ISO: 'HKG',
    NAME: 'Hong Kong',
    CODE: 'HK',
    NUMERIC_CODE: 20000,
    TELEPHONEACCESSCODE: 852,
  },
  {
    ISO: 'HUN',
    NAME: 'Hungary',
    CODE: 'HU',
    NUMERIC_CODE: 21000,
    TELEPHONEACCESSCODE: 36,
  },
  {
    ISO: 'IND',
    NAME: 'India',
    CODE: 'IN',
    NUMERIC_CODE: 23000,
    TELEPHONEACCESSCODE: 91,
  },
  {
    ISO: 'IDN',
    NAME: 'Indonesia',
    CODE: 'ID',
    NUMERIC_CODE: 24000,
    TELEPHONEACCESSCODE: 62,
  },
  {
    ISO: 'IRQ',
    NAME: 'Iraq',
    CODE: 'IQ',
    NUMERIC_CODE: 240,
    TELEPHONEACCESSCODE: 964,
  },
  {
    ISO: 'IRN',
    NAME: 'Iran',
    CODE: 'IR',
    NUMERIC_CODE: 239,
    TELEPHONEACCESSCODE: 98,
  },
  {
    ISO: 'ISR',
    NAME: 'Israel',
    CODE: 'IL',
    NUMERIC_CODE: 25000,
    TELEPHONEACCESSCODE: 972,
  },
  {
    ISO: 'CIV',
    NAME: "Côte d'Ivoire",
    CODE: 'CI',
    NUMERIC_CODE: 114,
    TELEPHONEACCESSCODE: 225,
  },
  {
    ISO: 'JPN',
    NAME: 'Japan',
    CODE: 'JP',
    NUMERIC_CODE: 116,
    TELEPHONEACCESSCODE: 81,
  },
  {
    ISO: 'YEM',
    NAME: 'Yemen',
    CODE: 'YE',
    NUMERIC_CODE: 13,
    TELEPHONEACCESSCODE: 967,
  },
  {
    ISO: 'JOR',
    NAME: 'Jordan',
    CODE: 'JO',
    NUMERIC_CODE: 118,
    TELEPHONEACCESSCODE: 962,
  },
  {
    ISO: 'CPV',
    NAME: 'Cabo Verde',
    CODE: 'CV',
    NUMERIC_CODE: 183,
    TELEPHONEACCESSCODE: 238,
  },
  {
    ISO: 'CMR',
    NAME: 'Cameroon',
    CODE: 'CM',
    NUMERIC_CODE: 180,
    TELEPHONEACCESSCODE: 237,
  },
  {
    ISO: 'KAZ',
    NAME: 'Kazakhstan',
    CODE: 'KZ',
    NUMERIC_CODE: 119,
    TELEPHONEACCESSCODE: 7,
  },
  {
    ISO: 'KEN',
    NAME: 'Kenya',
    CODE: 'KE',
    NUMERIC_CODE: 29000,
    TELEPHONEACCESSCODE: 254,
  },
  {
    ISO: 'KGZ',
    NAME: 'Kyrgyzstan',
    CODE: 'KG',
    NUMERIC_CODE: 123,
    TELEPHONEACCESSCODE: 7,
  },
  {
    ISO: 'KWT',
    NAME: 'Kuwait',
    CODE: 'KW',
    NUMERIC_CODE: 122,
    TELEPHONEACCESSCODE: 965,
  },
  {
    ISO: 'LAO',
    NAME: 'Lao',
    CODE: 'LA',
    NUMERIC_CODE: 124,
    TELEPHONEACCESSCODE: 856,
  },
  {
    ISO: 'LSO',
    NAME: 'Lesotho',
    CODE: 'LS',
    NUMERIC_CODE: 127,
    TELEPHONEACCESSCODE: 266,
  },
  {
    ISO: 'LBN',
    NAME: 'Lebanon',
    CODE: 'LB',
    NUMERIC_CODE: 32000,
    TELEPHONEACCESSCODE: 961,
  },
  {
    ISO: 'LBR',
    NAME: 'Liberia',
    CODE: 'LR',
    NUMERIC_CODE: 128,
    TELEPHONEACCESSCODE: 231,
  },
  {
    ISO: 'LBY',
    NAME: 'Libya',
    CODE: 'LY',
    NUMERIC_CODE: 130,
    TELEPHONEACCESSCODE: 218,
  },
  {
    ISO: 'LTU',
    NAME: 'Lithuania',
    CODE: 'LT',
    NUMERIC_CODE: 33000,
    TELEPHONEACCESSCODE: 370,
  },
  {
    ISO: 'LUX',
    NAME: 'Luxembourg',
    CODE: 'LU',
    NUMERIC_CODE: 34000,
    TELEPHONEACCESSCODE: 352,
  },
  {
    ISO: 'MAC',
    NAME: 'Macao',
    CODE: 'MO',
    NUMERIC_CODE: 133,
    TELEPHONEACCESSCODE: 853,
  },
  {
    ISO: 'MKD',
    NAME: 'Republic of North Macedonia',
    CODE: 'MK',
    NUMERIC_CODE: 215,
    TELEPHONEACCESSCODE: 389,
  },
  {
    ISO: 'MDG',
    NAME: 'Madagascar',
    CODE: 'MG',
    NUMERIC_CODE: 134,
    TELEPHONEACCESSCODE: 261,
  },
  {
    ISO: 'MWI',
    NAME: 'Malawi',
    CODE: 'MW',
    NUMERIC_CODE: 135,
    TELEPHONEACCESSCODE: 265,
  },
  {
    ISO: 'MDV',
    NAME: 'Maldives',
    CODE: 'MV',
    NUMERIC_CODE: 35000,
    TELEPHONEACCESSCODE: 960,
  },
  {
    ISO: 'MYS',
    NAME: 'Malaysia',
    CODE: 'MY',
    NUMERIC_CODE: 36000,
    TELEPHONEACCESSCODE: 60,
  },
  {
    ISO: 'MLI',
    NAME: 'Mali',
    CODE: 'ML',
    NUMERIC_CODE: 138,
    TELEPHONEACCESSCODE: 223,
  },
  {
    ISO: 'MTQ',
    NAME: 'Martinique',
    CODE: 'MQ',
    NUMERIC_CODE: 142,
    TELEPHONEACCESSCODE: 596,
  },
  {
    ISO: 'MRT',
    NAME: 'Mauritania',
    CODE: 'MR',
    NUMERIC_CODE: 143,
    TELEPHONEACCESSCODE: 222,
  },
  {
    ISO: 'MUS',
    NAME: 'Mauritius',
    CODE: 'MU',
    NUMERIC_CODE: 144,
    TELEPHONEACCESSCODE: 230,
  },
  {
    ISO: 'MEX',
    NAME: 'Mexico',
    CODE: 'MX',
    NUMERIC_CODE: 40000,
    TELEPHONEACCESSCODE: 52,
  },
  {
    ISO: 'MDA',
    NAME: 'Moldova',
    CODE: 'MD',
    NUMERIC_CODE: 81,
    TELEPHONEACCESSCODE: 373,
  },
  {
    ISO: 'MCO',
    NAME: 'Monaco',
    CODE: 'MC',
    NUMERIC_CODE: 41000,
    TELEPHONEACCESSCODE: 73,
  },
  {
    ISO: 'MNG',
    NAME: 'Mongolia',
    CODE: 'MN',
    NUMERIC_CODE: 83,
    TELEPHONEACCESSCODE: 976,
  },
  {
    ISO: 'MNE',
    NAME: 'Montenegro',
    CODE: 'ME',
    NUMERIC_CODE: 9974920,
    TELEPHONEACCESSCODE: 382,
  },
  {
    ISO: 'MSR',
    NAME: 'Montserrat',
    CODE: 'MS',
    NUMERIC_CODE: 84,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'MOZ',
    NAME: 'Mozambique',
    CODE: 'MZ',
    NUMERIC_CODE: 86,
    TELEPHONEACCESSCODE: 258,
  },
  {
    ISO: 'MMR',
    NAME: 'Myanmar',
    CODE: 'MM',
    NUMERIC_CODE: 87,
    TELEPHONEACCESSCODE: 95,
  },
  {
    ISO: 'NAM',
    NAME: 'Namibia',
    CODE: 'NA',
    NUMERIC_CODE: 88,
    TELEPHONEACCESSCODE: 264,
  },
  {
    ISO: 'NPL',
    NAME: 'Nepal',
    CODE: 'NP',
    NUMERIC_CODE: 90,
    TELEPHONEACCESSCODE: 977,
  },
  {
    ISO: 'NIC',
    NAME: 'Nicaragua',
    CODE: 'NI',
    NUMERIC_CODE: 95,
    TELEPHONEACCESSCODE: 505,
  },
  {
    ISO: 'NER',
    NAME: 'Niger',
    CODE: 'NE',
    NUMERIC_CODE: 227,
    TELEPHONEACCESSCODE: 227,
  },
  {
    ISO: 'NZL',
    NAME: 'New Zealand',
    CODE: 'NZ',
    NUMERIC_CODE: 94,
    TELEPHONEACCESSCODE: 64,
  },
  {
    ISO: 'NGA',
    NAME: 'Nigeria',
    CODE: 'NG',
    NUMERIC_CODE: 97,
    TELEPHONEACCESSCODE: 234,
  },
  {
    ISO: 'PRK',
    NAME: "Korea (the Democratic People's Republic of)",
    CODE: 'KP',
    NUMERIC_CODE: 100,
    TELEPHONEACCESSCODE: 850,
  },
  {
    ISO: 'UKR',
    NAME: 'Ukraine',
    CODE: 'UA',
    NUMERIC_CODE: 45000,
    TELEPHONEACCESSCODE: 380,
  },
  {
    ISO: 'OMN',
    NAME: 'Oman',
    CODE: 'OM',
    NUMERIC_CODE: 102,
    TELEPHONEACCESSCODE: 968,
  },
  {
    ISO: 'PAK',
    NAME: 'Pakistan',
    CODE: 'PK',
    NUMERIC_CODE: 103,
    TELEPHONEACCESSCODE: 92,
  },
  {
    ISO: 'PAN',
    NAME: 'Panama',
    CODE: 'PA',
    NUMERIC_CODE: 105,
    TELEPHONEACCESSCODE: 507,
  },
  {
    ISO: 'PNG',
    NAME: 'Papua New Guinea',
    CODE: 'PG',
    NUMERIC_CODE: 106,
    TELEPHONEACCESSCODE: 675,
  },
  {
    ISO: 'PRY',
    NAME: 'Paraguay',
    CODE: 'PY',
    NUMERIC_CODE: 107,
    TELEPHONEACCESSCODE: 595,
  },
  {
    ISO: 'PER',
    NAME: 'Peru',
    CODE: 'PE',
    NUMERIC_CODE: 108,
    TELEPHONEACCESSCODE: 51,
  },
  {
    ISO: 'PRI',
    NAME: 'Puerto Rico',
    CODE: 'PR',
    NUMERIC_CODE: 48,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'QAT',
    NAME: 'Qatar',
    CODE: 'QA',
    NUMERIC_CODE: 49,
    TELEPHONEACCESSCODE: 974,
  },
  {
    ISO: 'GIN',
    NAME: 'Guinea',
    CODE: 'GN',
    NUMERIC_CODE: 231,
    TELEPHONEACCESSCODE: 224,
  },
  {
    ISO: 'ROU',
    NAME: 'Romania',
    CODE: 'RO',
    NUMERIC_CODE: 49000,
    TELEPHONEACCESSCODE: 40,
  },
  {
    ISO: 'RWA',
    NAME: 'Rwanda',
    CODE: 'RW',
    NUMERIC_CODE: 53,
    TELEPHONEACCESSCODE: 250,
  },
  {
    ISO: 'SMR',
    NAME: 'San Marino',
    CODE: 'SM',
    NUMERIC_CODE: 55,
    TELEPHONEACCESSCODE: 378,
  },
  {
    ISO: 'SAU',
    NAME: 'Saudi Arabia',
    CODE: 'SA',
    NUMERIC_CODE: 57,
    TELEPHONEACCESSCODE: 966,
  },
  {
    ISO: 'SEN',
    NAME: 'Senegal',
    CODE: 'SN',
    NUMERIC_CODE: 58,
    TELEPHONEACCESSCODE: 221,
  },
  {
    ISO: 'SRB',
    NAME: 'Serbia',
    CODE: 'RS',
    NUMERIC_CODE: 197,
    TELEPHONEACCESSCODE: 381,
  },
  {
    ISO: 'SYC',
    NAME: 'Seychelles',
    CODE: 'SC',
    NUMERIC_CODE: 59,
    TELEPHONEACCESSCODE: 248,
  },
  {
    ISO: 'SLE',
    NAME: 'Sierra Leone',
    CODE: 'SL',
    NUMERIC_CODE: 60,
    TELEPHONEACCESSCODE: 232,
  },
  {
    ISO: 'SGP',
    NAME: 'Singapore',
    CODE: 'SG',
    NUMERIC_CODE: 51000,
    TELEPHONEACCESSCODE: 65,
  },
  {
    ISO: 'SDN',
    NAME: 'Sudan',
    CODE: 'SD',
    NUMERIC_CODE: 76,
    TELEPHONEACCESSCODE: 249,
  },
  {
    ISO: 'SOM',
    NAME: 'Somalia',
    CODE: 'SO',
    NUMERIC_CODE: 64,
    TELEPHONEACCESSCODE: 252,
  },
  {
    ISO: 'LKA',
    NAME: 'Sri Lanka',
    CODE: 'LK',
    NUMERIC_CODE: 55000,
    TELEPHONEACCESSCODE: 94,
  },
  {
    ISO: 'SUR',
    NAME: 'Suriname',
    CODE: 'SR',
    NUMERIC_CODE: 56000,
    TELEPHONEACCESSCODE: 597,
  },
  {
    ISO: 'SWZ',
    NAME: 'Eswatini',
    CODE: 'SZ',
    NUMERIC_CODE: 78,
    TELEPHONEACCESSCODE: 268,
  },
  {
    ISO: 'SYR',
    NAME: 'Syrian Arab Republic',
    CODE: 'SY',
    NUMERIC_CODE: 18,
    TELEPHONEACCESSCODE: 963,
  },
  {
    ISO: 'TWN',
    NAME: 'Taiwan',
    CODE: 'TW',
    NUMERIC_CODE: 20,
    TELEPHONEACCESSCODE: 886,
  },
  {
    ISO: 'TJK',
    NAME: 'Tajikistan',
    CODE: 'TJ',
    NUMERIC_CODE: 21,
    TELEPHONEACCESSCODE: 7,
  },
  {
    ISO: 'THA',
    NAME: 'Thailand',
    CODE: 'TH',
    NUMERIC_CODE: 59000,
    TELEPHONEACCESSCODE: 66,
  },
  {
    ISO: 'TON',
    NAME: 'Tonga',
    CODE: 'TO',
    NUMERIC_CODE: 26,
    TELEPHONEACCESSCODE: 676,
  },
  {
    ISO: 'TCD',
    NAME: 'Chad',
    CODE: 'TD',
    NUMERIC_CODE: 23,
    TELEPHONEACCESSCODE: 235,
  },
  {
    ISO: 'TZA',
    NAME: 'Tanzania',
    CODE: 'TZ',
    NUMERIC_CODE: 22,
    TELEPHONEACCESSCODE: 255,
  },
  {
    ISO: 'TUN',
    NAME: 'Tunisia',
    CODE: 'TN',
    NUMERIC_CODE: 61000,
    TELEPHONEACCESSCODE: 216,
  },
  {
    ISO: 'TUR',
    NAME: 'Turkey',
    CODE: 'TR',
    NUMERIC_CODE: 62000,
    TELEPHONEACCESSCODE: 90,
  },
  {
    ISO: 'TKM',
    NAME: 'Turkmenistan',
    CODE: 'TM',
    NUMERIC_CODE: 30,
    TELEPHONEACCESSCODE: 7,
  },
  {
    ISO: 'UGA',
    NAME: 'Uganda',
    CODE: 'UG',
    NUMERIC_CODE: 33,
    TELEPHONEACCESSCODE: 256,
  },
  {
    ISO: 'URY',
    NAME: 'Uruguay',
    CODE: 'UY',
    NUMERIC_CODE: 37,
    TELEPHONEACCESSCODE: 598,
  },
  {
    ISO: 'UZB',
    NAME: 'Uzbekistan',
    CODE: 'UZ',
    NUMERIC_CODE: 39,
    TELEPHONEACCESSCODE: 7,
  },
  {
    ISO: 'VEN',
    NAME: 'Venezuela',
    CODE: 'VE',
    NUMERIC_CODE: 42,
    TELEPHONEACCESSCODE: 58,
  },
  {
    ISO: 'ARE',
    NAME: 'United Arab Emirates',
    CODE: 'AE',
    NUMERIC_CODE: 35,
    TELEPHONEACCESSCODE: 971,
  },
  {
    ISO: 'USA',
    NAME: 'United States of America',
    CODE: 'US',
    NUMERIC_CODE: 63000,
    TELEPHONEACCESSCODE: 1,
  },
  {
    ISO: 'VNM',
    NAME: 'Vietnam',
    CODE: 'VN',
    NUMERIC_CODE: 43,
    TELEPHONEACCESSCODE: 84,
  },
  {
    ISO: 'BLR',
    NAME: 'Belarus',
    CODE: 'BY',
    NUMERIC_CODE: 164,
    TELEPHONEACCESSCODE: 375,
  },
  {
    ISO: 'ZMB',
    NAME: 'Zambia',
    CODE: 'ZM',
    NUMERIC_CODE: 14,
    TELEPHONEACCESSCODE: 260,
  },
  {
    ISO: 'ZWE',
    NAME: 'Zimbabwe',
    CODE: 'ZW',
    NUMERIC_CODE: 15,
    TELEPHONEACCESSCODE: 263,
  },
  {
    ISO: 'ZAF',
    NAME: 'South Africa',
    CODE: 'ZA',
    NUMERIC_CODE: 65,
    TELEPHONEACCESSCODE: 27,
  },
  {
    ISO: 'KOR',
    NAME: 'Korea (the Republic of)',
    CODE: 'KR',
    NUMERIC_CODE: 66,
    TELEPHONEACCESSCODE: 82,
  },
  {
    ISO: 'AND',
    NAME: 'Andorra',
    CODE: 'AD',
    TELEPHONEACCESSCODE: 376,
  },
  {
    ISO: 'COG',
    NAME: 'Congo',
    CODE: 'CG',
    TELEPHONEACCESSCODE: 243,
  },
  {
    ISO: 'DOM',
    NAME: 'Dominican Republic',
    CODE: 'DO',
    TELEPHONEACCESSCODE: 1809,
  },
  {
    ISO: 'GRD',
    NAME: 'Grenada',
    CODE: 'GD',
    TELEPHONEACCESSCODE: 1473,
  },
  {
    ISO: 'JAM',
    NAME: 'Jamaica',
    CODE: 'JM',
    TELEPHONEACCESSCODE: 1876,
  },
  {
    ISO: 'SXM',
    NAME: 'Sint Maarten',
    CODE: 'SX',
    TELEPHONEACCESSCODE: 1721,
  },
  {
    ISO: 'TTO',
    NAME: 'Trinidad and Tobago',
    CODE: 'TT',
    TELEPHONEACCESSCODE: 868,
  },
  {
    ISO: 'XKX',
    NAME: 'Kosovo',
    CODE: 'XK',
    TELEPHONEACCESSCODE: 383,
  },
  {
    ISO: 'KOM',
    NAME: 'Comoros',
    CODE: 'KM',
    TELEPHONEACCESSCODE: 269,
  },
  {
    ISO: 'ATG',
    NAME: 'Antigua and Barbuda',
    CODE: 'AG',
    TELEPHONEACCESSCODE: 1268,
  },
  {
    ISO: 'SSD',
    NAME: 'South Sudan',
    CODE: 'SS',
    TELEPHONEACCESSCODE: 211,
  },
  {
    ISO: 'PSE',
    NAME: 'Palestine',
    CODE: 'PS',
    TELEPHONEACCESSCODE: 970,
  },
  {
    ISO: 'VAT',
    NAME: 'Vatican City',
    CODE: 'VA',
    TELEPHONEACCESSCODE: 379,
  },
  {
    ISO: 'TLS',
    NAME: 'Timor-Leste',
    CODE: 'TL',
    TELEPHONEACCESSCODE: 670,
  },
  {
    ISO: 'TGO',
    NAME: 'Togo',
    CODE: 'TG',
    TELEPHONEACCESSCODE: 228,
  },
  {
    ISO: 'TUV',
    NAME: 'Tuvalu',
    CODE: 'TV',
    TELEPHONEACCESSCODE: 688,
  },
  {
    ISO: 'VUT',
    NAME: 'Vanuatu',
    CODE: 'VU',
    TELEPHONEACCESSCODE: 678,
  },
  {
    ISO: 'WSM',
    NAME: 'Samoa',
    CODE: 'WS',
    TELEPHONEACCESSCODE: 685,
  },
]
